import { render, staticRenderFns } from "./cTemplateAiPrompts.vue?vue&type=template&id=3e3d5065&scoped=true"
import script from "./cTemplateAiPrompts.vue?vue&type=script&setup=true&lang=js"
export * from "./cTemplateAiPrompts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cTemplateAiPrompts.vue?vue&type=style&index=0&id=3e3d5065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3d5065",
  null
  
)

export default component.exports